import { render } from "./LinesTable.vue?vue&type=template&id=ef442b8a&ts=true"
import script from "./LinesTable.vue?vue&type=script&lang=tsx"
export * from "./LinesTable.vue?vue&type=script&lang=tsx"

import "./LinesTable.vue?vue&type=style&index=0&id=ef442b8a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__